import React from "react";

export default function WeatherForecastDay(props) {
  function day() {
    let date = new Date(props.forecast.time * 1000);
    let day = date.getDay();
    let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    return days[day];
  }
  let mintemp = Math.round(props.forecast.temperature.minimum);
  let maxtemp = Math.round(props.forecast.temperature.maximum);
  let iconURL = props.forecast.condition.icon_url;

  return (
    <div className=" small-box">
      <div className="boxette">
        <div className="forecast-day day">{day()}</div>
        <div className="icon">
          <img src={iconURL} alt="" width="55" />
        </div>
        <div className="temp">
          <span className="min">{mintemp}</span>˚ |
          <span className="max"> {maxtemp}</span>
        </div>
      </div>
    </div>
  );
}
